exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/asna/front-end/public_html/src/app/components/login-signup/reset-password/reset-password.component.css
// module id = ../../../../../src/app/components/login-signup/reset-password/reset-password.component.css
// module chunks = main